/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useFacilityAlerts } from 'sarsaparilla';

import { FacilityAlertBanner } from '../components/FacilityAlertBanner/FacilityAlertBanner';

export function FacilityAlertBannerContainer({ className }: { className?: string }) {
    const alerts = useFacilityAlerts();

    return <FacilityAlertBanner alerts={alerts} className={className} />;
}
